<template>
  <Modal v-model="logisticsBindingModal" :title="$t('key1000561')" :transfer="false" :mask-closable="false"
    :width="logisticsBindingWidth" class-name="commonModalStyles" @on-visible-change="logisticsBindingChange">
    <!--单个绑定-->
    <template v-if="logisticsBindingType === 'single'">
      <Form ref="logisticsBindingForm" :model="logisticsBindingForm" :label-width="100" :rules="ruleValidate" @submit.native.prevent>
        <Row style="width: 80%;">
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1000562')" prop="shippingMethodId">
              <Select v-model="logisticsBindingForm.shippingMethodId" transfer filterable>
                <Option v-for="k in logisticsData" :value="k.shippingMethodId">{{ k.carrierShippingMethodName }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </template>
    <!--批量绑定-->
    <template v-else>
      <div class="logisticBinding_box">
        <div class="flex mb14 font-size-15 justify-content-between" style="padding-right: 188px;">
          <span class="themeColor">{{ $t('key1000564') }}</span>
          <span class="themeColor">{{ logisticsBindingTitle + $t('key1000563') }}</span>
        </div>
        <div class="logisticBinding_item" v-for="item in logisticsBindingData" :key="item.carrierId">
          <h2 class="color-333 font-weight-bold font-size-15">{{ item.carrierName }}</h2>
          <div class="logisticBinding_content" v-for="ele in item.carrierShippingMethods" :key="ele.shippingMethodId">
            <p class="width_250 ellipsis_1" :title="ele.carrierShippingMethodName">{{ ele.carrierShippingMethodName }}</p>
            <p class="width_140 text-align-center">{{ $t('key1000565') }}</p>
            <Select v-model="ele.logisticsValue" filterable class="width_280 pl30">
              <Option v-for="k in logisticsData" :value="k.shippingMethodId">{{ k.carrierShippingMethodName }}</Option>
            </Select>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <Button @click="logisticsBindingModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="logisticsBindingBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {_handleMultilingualFields} from "@/utils/common";

export default {
  name: 'logisticsBindingModal',
  mixins: [Mixin],
  data() {
    return {
      logisticsBindingModal: false,
      logisticsBindingForm: {
        shippingMethodId: null,
      },
      ruleValidate: {
        shippingMethodId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000556'), trigger: 'change'}
        ],
      },
      logisticsData: [],
      logisticsBindingTitle: '',
      logisticsBindingWidth: 600,
      logisticsBindingType: 'single',
      logisticsBindingData: [],
      detailsData: {},
      carrierCode: null
    };
  },
  methods: {
    // 初始化数据
    async initLogisticsBindingData(type, obj) {
      this.detailsData = obj;
      this.logisticsBindingType = type;
      this.carrierCode = obj.carrierCode;
      await this.getAllBaseLogisticsData(obj, type);
      this.logisticsData = await this.get3PLLogisticsData(obj);
      let overseasWarehouseCode = {
        winitoutstore: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000557'),
        miyunoutstore: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000558')
      }
      this.logisticsBindingTitle = overseasWarehouseCode[obj.carrierCode] || '';
      switch (type) {
        case 'all':
          this.logisticsBindingWidth = 800;
          break;
        case 'single':
          this.logisticsBindingWidth = 600;
          this.logisticsBindingForm.shippingMethodId = obj.overseaShippingMethodId || null;
          break;
      }
      this.logisticsBindingModal = true;
    },
    // 确定
    logisticsBindingBtn() {
      switch (this.logisticsBindingType) {
        case 'all':
          this.allBindingFun();
          break;
        case 'single':
          this.singleBindingFun();
          break;
      }
    },
    // 批量绑定
    allBindingFun() {
      let list = [];
      this.logisticsBindingData.map((item) => {
        let carrierShippingMethods = item.carrierShippingMethods || [];
        carrierShippingMethods.map((ele) => {
          let carrierShippingMethodId = null;
          let carrierShippingMethodWarehouseId = null;
          let carrierShippingMethodWarehouses = ele.carrierShippingMethodWarehouses || [];
          carrierShippingMethodWarehouses.map((k) => {
            if (k.warehouseId === this.detailsData.ymsWarehouseId) {
              carrierShippingMethodId = k.carrierShippingMethodId;
              carrierShippingMethodWarehouseId = k.carrierShippingMethodWarehouseId;
            }
          });
          if (ele.logisticsValue) {
            list.push({
              carrierShippingMethodId: carrierShippingMethodId,
              carrierShippingMethodWarehouseId: carrierShippingMethodWarehouseId,
              overseaShippingMethodId: ele.logisticsValue,
              warehouseId: this.detailsData.ymsWarehouseId
            });
          }
        });
      });
      if (list.length > 0) {
        this.axios.post(api.post_carrierShippingMethod_binding3PLShippingMethod, list,
          {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            this.logisticsBindingModal = false;
            this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000559'));
            this.$emit('updateData', true);
          }
        });
      } else {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000560'));
        return false;
      }
    },
    // 单个绑定
    singleBindingFun() {
      let carrierShippingMethodId = null;
      let carrierShippingMethodWarehouseId = null;
      this.logisticsBindingData.map((item) => {
        if (item.carrierCode === this.carrierCode) {
          let carrierShippingMethods = item.carrierShippingMethods || [];
          carrierShippingMethods.map((ele) => {
            let carrierShippingMethodWarehouses = ele.carrierShippingMethodWarehouses || [];
            carrierShippingMethodWarehouses.map((k) => {
              if (k.warehouseId === this.detailsData.ymsWarehouseId) {
                carrierShippingMethodId = k.carrierShippingMethodId;
                carrierShippingMethodWarehouseId = k.carrierShippingMethodWarehouseId;
              }
            });
          });
        }
      });
      let query = [{
        carrierShippingMethodId: carrierShippingMethodId,
        carrierShippingMethodWarehouseId: carrierShippingMethodWarehouseId,
        overseaShippingMethodId: this.logisticsBindingForm.shippingMethodId,
        warehouseId: this.detailsData.ymsWarehouseId
      }];
      this.$refs['logisticsBindingForm'].validate((valid) => {
        if (valid) {
          this.logisticsBindingModal = false;
          this.$emit('updateBindingInfo', query);
        }
      });
    },
    // 获取基础物流数据
    getAllBaseLogisticsData(obj, type) {
      const carrierShippingMethodWarehouses = obj.carrierShippingMethodWarehouses || [];
      let platformIdList = [];
      switch (obj.carrierCode) {
        // 万邑通仅支持配置：Tiktok物流、TEMU半托管线上发货
        case 'winitoutstore':
          platformIdList = ['temuHalfTl', 'tiktok'];
          break;
        // 米雲仓仅支持配置：Tiktok物流
        case 'miyunoutstore':
          platformIdList = ['tiktok'];
          break;
      }
      return new Promise((resolve) => {
        this.axios.get(api.get_carrier_queryForEnableCarriers).then(({data}) => {
          if (data.code !== 0) return resolve([]);
          if (type === 'all') {
            const newData = (data.datas || []).filter(item => platformIdList.includes(item.carrierCode))
              .map(item => {
                const carrierShippingMethods = (item.carrierShippingMethods || [])
                  .filter(m => carrierShippingMethodWarehouses.includes(m.shippingMethodId)).map(m => (
                    {
                      ...m,
                      carrierShippingMethodName: _handleMultilingualFields(m.carrierShippingMethodName),
                      logisticsValue: null
                    }));
                carrierShippingMethods.map(k => {
                  let carrierShippingMethodWarehousesList = k.carrierShippingMethodWarehouses || [];
                  carrierShippingMethodWarehousesList.map((j) => {
                    if (j.warehouseId === this.detailsData.ymsWarehouseId) {
                      k.logisticsValue = j.overseaShippingMethodId;
                    }
                  });
                });
                return {
                  ...item,
                  carrierShippingMethods
                };
              }).filter(item => item.carrierShippingMethods.length > 0);
            this.logisticsBindingData = newData;
            resolve(newData);
          } else {
            const newData = (data.datas || []).filter(item => platformIdList.includes(item.carrierCode));
            this.logisticsBindingData = newData;
            resolve(newData);
          }
        });
      });
    },
    // 物流数据
    async get3PLLogisticsData(obj) {
      const {apiWarehouseId, ymsWarehouseId, carrierCode} = obj;
      const query = `?apiWarehouseId=${apiWarehouseId}&ymsWarehouseId=${ymsWarehouseId}`;
      try {
        const response = await this.axios.get(api.get_ymsWarehouse_getEnableThirdShippingMethods + query);
        if (response.data.code !== 0) {
          return [];
        }
        const data = response.data.datas || {};
        const list = data?.enableThirdCarrierShippingMethods || [];
        return carrierCode === 'winitoutstore' ? list.filter(item => item.carrierShippingMethodName.includes('3PL')) : list;
      } catch (e) {
        return [];
      }
    },
    // 监听弹窗
    logisticsBindingChange(value) {
      if (!value) {
        this.logisticsBindingData = [];
        this.detailsData = {};
        this.carrierCode = null;
        this.$nextTick(() => {
          if (this.logisticsBindingType === 'single') {
            this.$refs['logisticsBindingForm'].resetFields();
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.commonModalStyles /deep/ {
  .logisticBinding_box {
    .logisticBinding_item {
      margin-bottom: 20px;

      .logisticBinding_content {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
      }
    }
  }
}
</style>
